import { Module } from 'vuex';

import { RootState, AccountDeactivatedMessage } from 'frontend/types';

const accountDeactivatedMessage: Module<AccountDeactivatedMessage, RootState> = {
  namespaced: true,
  state: () => ({
    show_just_deactivated_account_message: undefined,
    permament_delete: undefined,
    deactivation_subscription_cancelled: undefined,
    deactivation_subscription_refunded: undefined,
  }),
  getters: {
    subscriptionCancelled: (state: AccountDeactivatedMessage): boolean => {
      return state.deactivation_subscription_cancelled === true;
    },
    subscriptionRefunded: (state: AccountDeactivatedMessage): boolean => {
      return state.deactivation_subscription_refunded === true;
    },
  },
  mutations: {
    setValue(state, value: AccountDeactivatedMessage): void {
      Object.assign(state, value);
    },
  },
};

export default accountDeactivatedMessage;
